import { render, staticRenderFns } from "./ScholarshipsTable.vue?vue&type=template&id=2bf42e6c"
import script from "./ScholarshipsTable.vue?vue&type=script&lang=js"
export * from "./ScholarshipsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports